<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.headphones"
    subtitle="Enterprise Support"
    title="First-class support when you need it"
    description="Dedicated support channels and SLA guarantees for your peace of mind"
  />
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.message-circle" class="mr-2" />
        <h3 class="text-xl font-bold">Priority Support</h3>
      </div>
      <p class="text-pretty text-lg">
        Fast-track support with guaranteed response times and priority
        escalation for critical issues
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.phone" class="mr-2" />
        <h3 class="text-xl font-bold">Dedicated Support Channels</h3>
      </div>
      <p class="text-pretty text-lg">
        Direct access to our engineering team through dedicated Slack channels
        and phone support
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.file-text" class="mr-2" />
        <h3 class="text-xl font-bold">Service Level Agreement</h3>
      </div>
      <p class="text-pretty text-lg">
        Contractual SLA guarantees for uptime, response times, and resolution
        commitments
      </p>
    </div>
    <!-- <app-enterprise-openforge-migration-service-card /> -->
  </div>
</section>
